<template v-slot="title">
  <div class="icon-container">
    <svg-icon v-if="icon" :icon-class="icon" /><span>{{ title||'--' }}</span>
  </div>
</template>
<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
  .icon-container {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .sub-el-icon {
    color: currentColor;
    width: 1em;
    height: 1em;
  }
</style>
